import { Download } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { Tooltip } from "react-tooltip";

export const styles = {
    cardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },
    cardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
        marginBottom: -5,
    },
    fontSizeFiftin: {
        fontSize: 15
    },
    divider: {
        borderBottomWidth: 1,
        height: 5,
    },
    dwnldAssetMasterStyle: {
        marginTop: 2,
        marginBottom: 2,
        marginLeft: 13,
    },

    assetmasterCard: {
        backgroundColor: "#EEF2F7",
        padding: "1.3rem",
    },
    assetmasterCardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
    },
    locContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
    },
    dwnldAssetMasterbttnStyle: {
        display: 'flex',
        justifyContent: { xs: 'flex-start', sm: 'center' },
        alignItems: 'center', justifyContent: 'flex-start'
    },

    fileStyle: {
        display: { lg: "flex", md: "flex" },
        gap: "1rem",
    },
    fileInputStyle: {
        border: "1px solid lightgrey",
        borderRadius: "5px",
    },
    buttonBox: {
        display: "flex",
        alignItems: "center",
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "16px",
        marginLeft: "1rem",
    },
    card: {
        backgroundColor: "#EEF2F7",
        padding: "0.5rem",
    },
    cardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },

    cardTitle: {
        fontSize: "16px",
        fontWeight: "600",
        lineHeight: "16px",
        color: "#0160F1",
    },
    cardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
    },
    deviderStyle: {
        marginRight: 2,
        marginLeft: 2,
        backgroundColor: "#c0c0c0",
        width: 2,
    },
};

export const boxSX = {
    textDecoration: "none",
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
        color: "darkblue",
    },
};

const HoverCell = ({ value }) => {
    return (
        <Tooltip
            title={
                <span style={{ fontSize: "16px" }}>{value}</span>
            }
        >
            <div
                style={{
                    whiteSpace: "none",
                    textAlign: "start",
                    maxWidth: "100%",
                }}
            >{value}</div>
        </Tooltip>
    );
};
export const columns = (downloadProcessLog) => [
    {
        field: 'sr_no',
        headerName: 'Sr no',
        headerAlign: 'center',
        align: 'center',
        flex: 0.5,
        renderCell: (params) => (
            <div>
                {params.id}
            </div>
        )
    },
    // {
    //     field: "file_name",
    //     headerName: "File Name",
    //     flex: 1.5,
    //     wordBreak: "break-word",
    //     width: 150,
    //     renderCell: (params) => {
    //         return <HoverCell value={params.value} />;
    //     },
    // },
    {
        field: 'file_name',
        headerName: 'File Name',
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (
            <div style={{ textAlign: 'center' }}>{params.value}</div>
        ),
    },
    {
        field: 'created_at',
        headerName: 'Date',
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (
            <div style={{ textAlign: 'center' }}>{params.value}</div>
        ),
    },
    {
        field: 'log_id',
        headerName: 'Log Id',
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (
            <div style={{ textAlign: 'center' }}>{params.value}</div>
        ),
    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (
            <div style={{
                textAlign: 'center', color: params.value === 'Success' || params.value === "Partial Success" ? 'green' : 'red',
            }}>{params.value}</div>
        ),
    },
    {
        field: 'records_processed',
        headerName: (
            <div style={{ textAlign: 'center', whiteSpace: 'pre-wrap' }}>
                No of records processed
            </div>
        ),
        flex: 1,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: "current_status",
        headerName: "Progress",
        headerAlign: "center",
        align: "center",
        flex: 1,
        renderCell: (params) => {
            return (
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    width="100%"
                    height="100%"
                    textAlign="center"
                    style={{
                        lineHeight: 1.5,
                    }}
                >
                    <Typography
                        style={{
                            fontSize: "0.9rem",
                            marginBottom: "4px",
                        }}
                    >
                        {params.value}
                    </Typography>

                </Box>
            );
        },
    }
    ,
    {
        field: "process_log",
        headerName: "Process Log",
        flex: 1,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => (
            <div style={styles.processLogCell}>
                <IconButton
                    aria-label="Download Process Log"
                    onClick={() => downloadProcessLog(params.row.log_id)}
                >
                    <Download color="primary" />
                </IconButton>
            </div>
        ),
    },

];
export default styles;




